<template>
  <div class="snList" v-if="auth.list">
    <el-form ref="searchForm" :model="search" size="mini" :inline="true" :label-position="position">
      <el-form-item>
        <el-input v-model="search.sn" placeholder="小码" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-select v-model="search.orgId" filterable  placeholder="组织" clearable>
          <el-option v-for="item in orgList"
            :key="item.deptId"
            :label="item.deptName"
            :value="item.deptId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="searcherSubmit">查询</el-button>
      </el-form-item>
    </el-form>
    <el-row :gutter="2">
      <el-col :xs="10">
        <el-table :data="snList" style="width: 100%;" border :fit="true"
                  :header-cell-style="{'text-align':'center'}">
          <el-table-column prop="materialNumber" label="物料编码" sortable resizable :show-overflow-tooltip="true"
                           align="center" />
          <el-table-column  prop="materialName" label="物料名称" sortable resizable :show-overflow-tooltip="true"
                            align="center"></el-table-column>
          <el-table-column prop="modelName" label="物料型号" sortable resizable :show-overflow-tooltip="true"   align="center"  />
          <el-table-column prop="warehouseName" label="所属仓库" sortable resizable :show-overflow-tooltip="true"  align="center" />
          <el-table-column prop="warehouseTypeName" label="仓库类型" sortable resizable :show-overflow-tooltip="true"  align="center"   />
          <el-table-column prop="sn" label="物料小码" sortable resizable :show-overflow-tooltip="true"
                           align="center"></el-table-column>
          <el-table-column  label="操作" sortable resizable :show-overflow-tooltip="true"
                            align="center">
            <template slot-scope="scope">
              <el-button type="text"  @click="getLife(scope.row)"size="small">生命周期</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination align='left'
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="pages.page"
                       :page-sizes="[10, 20, 50, 100]"
                       :page-size="pages.pageSize"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pages.total">
        </el-pagination>
      </el-col>
    </el-row>
    <el-dialog
      title="提示"
      :visible.sync="centerDialogVisible"
      width="30%"
      center>
      <el-timeline :reverse="true">
        <el-timeline-item v-for="(activity, index) in  lifeList"
                          :key="index"
                          :timestamp="activity.createtime">
          <el-card>
            <h4>{{activity.opeContent}},单据编码:<span style="color:#d82c10" @click="handleCopy(activity.lineOrderNumber,$event)" >{{activity.lineOrderNumber}}</span></h4>
            <p>{{activity.createUser}} 提交于 {{dateFormat(activity.createTime)}}</p>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </el-dialog>
  </div>
</template>

<script>
  import {querySnLife, getCurrentOrg, getLifeCycle} from "../../api/api";
  import {getPermission} from '../../api/authRequest'
  import {hideLoading, showLoading} from "../../components/loading/loading";
  import clip from '@/util/clipboard'
  export default {
    data() {
      return {
        auth: {
          list: false,
        },
        search:{},
        snList:[],
        snLifeInfo:{},
        sn:"",
        pages: {
          page: 1,
          pageSize: 10,
          total: 0
        },
        position:'left',
        orgList:[],
        lifeList:[],
        centerDialogVisible:false
      }
    },
    mounted() {
      this.auth.list = getPermission('/api/snLife/query');
      this.getSnLife();
      this.getOrg();
    },
    methods: {
      //查询
      searcherSubmit(){
        let  _self=this;
        _self.snLifeInfo.sn=_self.search.sn;
        _self.snLifeInfo.orgId=_self.search.orgId;
        showLoading();
        _self.getSnLife();
        },
      handleSizeChange(val) {
        this.pages.pageSize = val;
        showLoading();
        this.getSnLife()
      },
      handleCurrentChange(Page) {
        this.pages.page = Page;
        showLoading();
        this.getSnLife()
      },
      //获取列表
      getSnLife(){
        let _self=this;
        let param={
          sn:_self.snLifeInfo.sn,
          orgId:_self.snLifeInfo.orgId,
          pageSize: _self.pages.pageSize,
          startRow: _self.pages.page,
        };
        querySnLife(param).then(response=>{
          hideLoading();
          if (response.data.status == 100) {
            _self.snList = response.data.results.list;
            _self.pages.total = response.data.results.total;
          }
        }).catch((error) => {
          this.$Message.error(error.message);
        })
      },
      //获取当前租户组织
      getOrg(){
        let _self=this;
        let  params={

        };
        getCurrentOrg(params).then(response=>{
          if (response.data.status == 100) {
            _self.orgList=response.data.results;
          }
        }).catch((error) => {
          this.$Message.error(error.message);
        })
      },
      //查看生命周期
      getLife(row){
        this.sn=row.sn;
        this.getLifeBySn();
      },
      getLifeBySn(){
        let _self=this;
        let params={
          sn:_self.sn,
        };
        getLifeCycle(params).then(response=>{
          hideLoading();
          if (response.data.status == 100) {
            _self.lifeList=response.data.results;
            _self.centerDialogVisible=true;
          }
        }).catch((error) => {
          this.$Message.error(error.message);
        })
      },
      ////复制内容
      handleCopy(text, event) {
        clip(text, event)
      },
      dateFormat(date){
        if (!date) {
          return "";
        }else {
          let d = new Date(date);
          let month = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1);
          let day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();
          let hours = d.getHours() < 10 ? '0' + d.getHours() : d.getHours();
          let min = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();
          let sec = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds();

          let times = d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
          return times;
        }
      }
    }
  }
</script>

<style type="text/css" lang="scss" scoped>
  .snList {
    .box-card {
      margin-bottom: 20px;
      border-radius: 0px;

      .card-header {
        font-size: 14px;
        line-height: 0px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// snList.vue?0613e9d5